import {BaseStormpathAccount} from 'angular-stormpath';
import _ = require('lodash');
/**
 * Created by Rodrigo Quesada on 23/03/17.
 */

export class Principal {

    get id(): string { return this._account.href; }

    readonly roles: string[];

    firstLogin: boolean = false;

    constructor(private _account: BaseStormpathAccount) {
        this.roles = this._account['groups'].items.map(g => g.name);
    }

    hasAnyRole(roles: string[]): boolean { return roles.some(role => _.includes(this.roles, role)); }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/security/authorization/principal.class.ts